import env from 'core/pkg/env'

export default {
  init(options = {}, services) {
    return env.init(
      Object.assign(
        {},
        {
          // resources: configs
        },
        options
      )
    )
  }
}
